module.exports = __webpack_public_path__ + "static/media/canva.46874cc5.png";